'use client';

import { Modal } from '@1debit/chimekit';
import { Info } from '@1debit/icons';
import type { ReactNode } from 'react';
import { getButtonStyles } from 'components/shared/Buttons/BaseButton';
import { HINT_TOGGLE_CLASS, HINT_TOGGLE_LABEL_PREFIX } from 'components/Widget/CalculatorInput/constants';

const CLOSE_BUTTON_CLASS =
  'border border-kale hover:border-content-secondary hover:text-content-secondary active:border-content-secondary active:text-content-secondary';

interface HintDisclosureProps {
  hintId: string;
  label: string;
  hint: ReactNode;
}

export const HintDisclosure = ({ hintId, label, hint }: HintDisclosureProps) => (
  <Modal analyticsId={null}>
    <Modal.Trigger
      analyticsId={null}
      variant="link"
      aria-label={`${HINT_TOGGLE_LABEL_PREFIX} ${label}`}
      className={HINT_TOGGLE_CLASS}>
      <Info aria-hidden className="size-[18px]" />
    </Modal.Trigger>

    {/* Outside the dialog so `aria-describedby` resolves without opening it. */}
    <p id={hintId} className="sr-only">
      {hint}
    </p>

    <Modal.Content className="box-content animate-modal-slide-in data-[state=open]:translate-y-0 sm:rounded-[10px] sm:px-[60px] sm:pt-5 sm:pb-10">
      <Modal.Body className="sm:px-0">
        <Modal.Title className="font-sans text-heading-md">{label}</Modal.Title>
        <div className="my-[10px] font-serif text-body-serif">{hint}</div>
      </Modal.Body>
      <Modal.Footer className="sm:pb-0 sm:pl-0">
        <div className="w-full sm:w-1/2">
          {/* Styled rather than wrapped in `BaseButton`, which would nest a second chimekit Button inside this one. */}
          <Modal.Close analyticsId={null} className={getButtonStyles('outline', CLOSE_BUTTON_CLASS)}>
            Close
          </Modal.Close>
        </div>
      </Modal.Footer>
    </Modal.Content>
  </Modal>
);
